import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["size", "color", "alignWithText", "aria-label", "id"];
// THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY.

import { useTheme } from 'foundations-theming/utils';
import { useIconSize } from 'foundations-assets/icons/useIconSize';
import { StyledIcon } from 'foundations-assets/icons/StyledIcon';
import { getDataProps } from 'foundations-assets/icons/getDataProps';
import { jsx as _jsx } from "react/jsx-runtime";
export const SocialSharePointIcon = _ref => {
  let {
      size: sizeProp,
      // We don't set the default value here because we want to know if a consumer passed in a value
      color: colorProp,
      // We don't set the default value here because we want to know if a consumer passed in a value
      alignWithText = false,
      'aria-label': ariaLabel,
      id
    } = _ref,
    restProps = _objectWithoutPropertiesLoose(_ref, _excluded);
  const theme = useTheme();
  const dataProps = getDataProps(restProps);

  // Setting default values here
  const size = sizeProp !== null && sizeProp !== void 0 ? sizeProp : 'inherit';
  const color = colorProp !== null && colorProp !== void 0 ? colorProp : 'inherit';
  const sizeValue = useIconSize(size);
  const sizeCSSValue = sizeProp ? `${sizeValue} !important` : sizeValue; // Adds the `!important` flag to the `size` value if one is provided via props

  const colorValue = color === 'inherit' ? 'currentColor' : theme.color[color]; // inherit = currentColor = text color of the parent element
  const colorCSSValue = colorProp ? `${colorValue} !important` : colorValue; // Adds the `!important` flag to the `color` value if one is provided via props

  return /*#__PURE__*/_jsx(StyledIcon, Object.assign({}, dataProps, {
    $size: sizeCSSValue,
    $color: colorCSSValue,
    $alignWithText: alignWithText,
    "aria-label": ariaLabel,
    "aria-hidden": ariaLabel === undefined ? true : undefined,
    id: id,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    focusable: "false",
    "data-icon-name": "SocialSharePoint",
    children: /*#__PURE__*/_jsx("path", {
      d: "M18.58 0s-.09 0-.14.02L.52 3.4c-.3.06-.52.33-.52.64V27.9c0 .31.22.58.52.64l17.92 3.44s.08.02.12.02c.15 0 .28-.05.4-.14a.65.65 0 0 0 .24-.5V.64a.65.65 0 0 0-.24-.5.6.6 0 0 0-.38-.14m1.9 5.18v7.56c1.48-.24 2.64-1.3 3.04-2.7 1.23.51 2.26 1.38 2.98 2.5-1.29.62-2.18 1.94-2.18 3.46s.89 2.82 2.16 3.44a6.6 6.6 0 0 1-2.98 2.46 3.76 3.76 0 0 0-3.02-2.64v7.56c1.78-.29 3.1-1.76 3.18-3.62 1.73-.63 3.15-1.8 4.08-3.38.14.01.28.02.42.02a3.841 3.841 0 0 0 0-7.68c-.12 0-.26 0-.38.02a7.76 7.76 0 0 0-4.12-3.44c-.1-1.83-1.42-3.28-3.18-3.56M9.34 9.86c.64 0 1.15.06 1.6.12s.9.19 1.28.32v2.5c-.19-.13-.39-.25-.64-.38s-.44-.19-.7-.26-.51-.12-.7-.12c-.26-.06-.44-.08-.7-.08-.32 0-.59.02-.84.08s-.45.11-.64.24-.32.27-.38.4c-.07.13-.14.31-.14.5s.07.39.14.52c.13.13.25.31.44.44s.44.25.7.38.58.27.9.4c.45.19.89.39 1.28.64.39.19.7.44.96.76.26.25.45.58.64.96.13.39.2.77.2 1.22-.06.7-.19 1.21-.38 1.66-.26.45-.59.83-1.04 1.08s-.89.45-1.46.58-1.16.2-1.8.2-1.28-.07-1.86-.2c-.57-.07-1.08-.25-1.46-.44v-2.62c.45.39.97.69 1.54.88s1.09.32 1.66.32c.32 0 .64 0 .9-.06.26-.07.45-.13.64-.26s.31-.25.38-.38c.06-.13.12-.31.12-.44 0-.25-.05-.45-.18-.64s-.33-.33-.52-.52c-.26-.13-.52-.31-.84-.44s-.64-.27-1.02-.46c-.89-.39-1.59-.82-2.04-1.4-.45-.57-.7-1.21-.7-1.98 0-.64.12-1.15.38-1.6s.57-.78 1.02-1.1c.45-.26.9-.51 1.48-.64s1.14-.18 1.78-.18"
    })
  }));
};
SocialSharePointIcon.displayName = 'SocialSharePointIcon';